<template>
  <v-dialog
    v-model="isBioDialogOpen"
    max-width="650px"
    @click:outside="$emit('update:is-bio-dialog-open',false)"
  >
    <v-card class="pa-sm-10 pa-3">
      <v-card-title class="justify-center text-h5">
        Editar informações do usuário
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form class="multi-col-validation">
          <v-row>
            <v-col
              sm="6"
              cols="12"
            >
              <v-text-field
                v-model="colaboradorAccountData.nome"
                dense
                outlined
                label="Nome"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-text-field
                v-model="colaboradorAccountData.sobrenome"
                dense
                outlined
                label="Sobrenome"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-text-field
                v-model="colaboradorAccountData.login"
                prefix="@"
                dense
                outlined
                label="Login"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-text-field
                v-if="colaboradorData.cpf"
                :value="maskCpf(colaboradorData.cpf)"
                label="CPF"
                dense
                outlined
                readonly
              />

              <v-text-field
                v-else
                v-model="colaboradorAccountData.cpf"
                v-mask="'###.###.###-##'"
                label="CPF"
                dense
                outlined
                :rules="[validators.isCpfValido]"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-select
                v-model="colaboradorAccountData.cargoId"
                dense
                outlined
                label="Cargo"
                placeholder="Cargo"
                item-text="nome"
                item-value="id"
                hide-details
                :items="cargos"
                :rules="[validators.select]"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-select
                v-model="colaboradorAccountData.departamentoId"
                dense
                outlined
                label="Departamento"
                placeholder="Departamento"
                item-text="nome"
                item-value="id"
                hide-details
                :items="departamentos"
                :rules="[validators.select]"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-select
                v-model="colaboradorAccountData.perfilId"
                dense
                outlined
                label="Perfil"
                placeholder="Perfil"
                item-text="nome"
                item-value="id"
                hide-details
                :items="perfis"
                :rules="[validators.select]"
              />
            </v-col>

            <v-col
              sm="6"
              cols="12"
            >
              <v-select
                v-model="colaboradorAccountData.atuacaoId"
                dense
                outlined
                label="Atuação"
                placeholder="Atuação"
                item-text="nome"
                item-value="id"
                hide-details
                :items="atuacoes"
                :rules="[validators.select]"
              />
            </v-col>

            <v-col
              cols="12"
              class="d-flex justify-center mt-3"
            >
              <v-btn
                color="primary"
                class="me-3"
                type="submit"
                @click="update"
                @click.prevent="updateColaborador"
              >
                Confirmar
              </v-btn>

              <v-btn
                outlined
                color="secondary"
                @click="$emit('update:is-bio-dialog-open',false)"
                @click.prevent="resetForm"
              >
                Descartar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { emailValidator, required, select, alphaValidator, passwordValidator } from '@core/utils/validation'
import { isTelefoneCelularValido, isCpfValido, maskCpf } from '@/utils/validation'
import CargoService from '@/services/modules/CargoService'
import ColaboradorService from '@/services/modules/ColaboradorService'
import DepartamentoService from '@/services/modules/DepartamentoService'
import PerfilService from '@/services/modules/PerfilService'

export default {
  props: {
    isBioDialogOpen: {
      type: Boolean,
      required: true,
    },
    colaboradorData: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    departamentos: [],
    cargos: [],
    perfis: [],
    atuacoes: [
      { nome: 'Gestor', id: 1 },
      { nome: 'Agente', id: 2 },
    ],
  }),

  mounted() {
    this.getDepartamento()
    this.getCargo()
    this.getPerfil()
  },

  setup(props, { emit }) {
    const colaboradorAccountData = ref(JSON.parse(JSON.stringify(props.colaboradorData)))

    const resetForm = () => {
      colaboradorAccountData.value = JSON.parse(JSON.stringify(props.colaboradorData))
    }

    const updateColaborador = () => {
      emit('update:is-bio-dialog-open', false)
    }

    watch(
      () => props.isBioDialogOpen,
      () => {
        colaboradorAccountData.value = JSON.parse(JSON.stringify(props.colaboradorData))
      },
    )

    return {
      colaboradorAccountData,
      updateColaborador,
      resetForm,
      validators: {
        required,
        emailValidator,
        select,
        alphaValidator,
        isCpfValido,
        passwordValidator,
        isTelefoneCelularValido,
      },
    }
  },

  methods: {
    maskCpf,

    update() {
      ColaboradorService.update(this.colaboradorAccountData.id, this.colaboradorAccountData)
    },

    async getDepartamento() {
      this.departamentos = await DepartamentoService.get()
    },

    async getCargo() {
      this.cargos = await CargoService.get()
    },

    async getPerfil() {
      this.perfis = await PerfilService.get()
    },

  },
}
</script>
